module.exports = __webpack_public_path__ + "media/customer_tickets/bell-5ad1c5d1.svg";